import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aum_in_base_currency: {
    name: 'Total AuM amount of the AIF in base currency',
    order: 48
  },
  base_currency: {
    name: 'Base currency of the AIF',
    order: 49
  },
  fx_eur_rate: { name: 'Base currency / EUR FX rate', order: 50 },
  fx_eur_reference_rate_type: {
    name: 'Base currency / EUR FX reference rate type',
    order: 51
  },
  fx_eur_other_reference_rate_description: {
    name: 'Base currency / EUR FX reference rate description for no ECB rates',
    order: 52
  },
  total_net_asset_value: {
    name: 'Total Net Asset Value of the AIF (NAV)',
    order: 53
  }
};

export function BaseCurrency({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.BASE_CURRENCY_INFORMATION,
    onChangeFund,
    schema: schema.BASE_CURRENCY_INFORMATION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.BASE_CURRENCY_INFORMATION?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'BASE_CURRENCY_INFORMATION',
    columnLables
  });

  return (
    <Table
      id="reporttables-base-currency-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
